import { Lightbox } from '@components/Lightbox'
import tw, { styled } from 'twin.macro'
import CloseIcon from '@components/Icons/CloseIcon'
import PublishTimeSection from './PublishTimeSection'

type Props = {
  close: () => void
}

const PublishSettingLightbox = (props: Props) => {
  const { close } = props

  const headerContent = (
    <Header>
      <Close onClick={close} />
      <Title>發布時間</Title>
      <Finish>{/* FIXME: 發布按鈕應該在這邊 */}</Finish>
    </Header>
  )

  const mainContent = (
    <Main tw="space-y-6">
      <PublishTimeSection />
    </Main>
  )

  return <Lightbox close={close} headerContent={headerContent} mainContent={mainContent} />
}

const Header = styled.div`
  padding: 16px;
  display: grid;
  grid-template: 'close center finish' / auto 1fr auto;
  justify-items: center;
  align-items: center;
`

const Close = styled(CloseIcon)`
  grid-area: close;
`

const Finish = styled.div`
  grid-area: finish;
  font-weight: 500;
  ${tw`text-primary-indigo`};
`

const Title = styled.div`
  grid-area: center / close / center / finish;
  font-weight: 500;
  line-height: 1.35;
  ${tw`text-gray-800`};
`

const Main = styled.div`
  padding: 16px 8px;
  .preview {
    display: none;
  }
`

export default PublishSettingLightbox
